var map = {
	"./feature_buy_en.png": "1696",
	"./feature_buy_id.png": "707e",
	"./feature_buy_my.png": "6109",
	"./feature_buy_ph.png": "abbd",
	"./feature_buy_th.png": "5c8c",
	"./feature_buy_zh.png": "dc16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d42f";